module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.32400f4e.eot";